module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1227.647a04b0.png";